
import { defineComponent } from "vue";

import StudentAttendanceContent from "./components/StudentAttendanceContent.vue";

export default defineComponent({
  name: "StudentAttendancePage",
  components: {
    StudentAttendanceContent
  },
});
